"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _jsxRuntime = require("react/jsx-runtime");
const SQUARES_SIZE = 27;
const CUSTOM_TABLET_BREAKPOINT = _mui.theme.breakpoints.up(1025);
const UnifiedSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'none'
});
const RootWrapper = (0, _mui.styled)('div')({
  height: _presentationUtils.MOBILE_HEIGHT,
  gridTemplateColumns: '1fr 100px 1fr',
  padding: '0 17px',
  boxSizing: 'border-box',
  [CUSTOM_TABLET_BREAKPOINT]: {
    gridTemplateColumns: '1fr 180px 1fr',
    height: _presentationUtils.DESKTOP_HEIGHT,
    padding: '0 45px 0 30px'
  }
});
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  // TODO [14-12-2021]: Could this value be "sticky"? Think about it after moving top-area to appshell.
  position: 'fixed',
  alignItems: 'center',
  justifyContent: 'space-between',
  top: 0,
  left: 0,
  background: 'white',
  zIndex: 1001,
  width: '100vw',
  height: _presentationUtils.MOBILE_HEIGHT,
  gridTemplateColumns: '1fr 100px 1fr',
  padding: '0 17px',
  boxSizing: 'border-box',
  [CUSTOM_TABLET_BREAKPOINT]: {
    gridTemplateColumns: '1fr 180px 1fr',
    height: _presentationUtils.DESKTOP_HEIGHT,
    padding: '0 45px 0 30px'
  },
  [theme.breakpoints.up(1200)]: {
    padding: '0 55px 0 40px'
  },
  [theme.breakpoints.up(1536)]: {
    padding: '0 75px 0 60px'
  }
}));
const LogoSkeleton = (0, _mui.styled)(UnifiedSkeleton)(({
  theme
}) => ({
  width: 105,
  [CUSTOM_TABLET_BREAKPOINT]: {
    width: 180
  }
}));
const LeftSideRoot = (0, _mui.styled)('div')({
  display: 'flex'
});
const LeftSideSkeletonItem = (0, _mui.styled)(UnifiedSkeleton)(({
  theme
}) => ({
  display: 'inline-block',
  '&:nth-of-type(2)': {
    marginLeft: 30,
    [CUSTOM_TABLET_BREAKPOINT]: {
      marginLeft: 42,
      marginRight: 40
    }
  },
  '&:last-of-type': {
    display: 'none',
    [CUSTOM_TABLET_BREAKPOINT]: {
      display: 'block'
    }
  }
}));
const RightSideRoot = (0, _mui.styled)('div')({
  display: 'flex',
  alignItems: 'center',
  gridColumn: '3/4',
  justifySelf: 'end'
});
const SearchBarSkeleton = (0, _mui.styled)(UnifiedSkeleton)(({
  theme
}) => ({
  borderRadius: '999px',
  marginRight: '50px',
  display: 'none',
  [CUSTOM_TABLET_BREAKPOINT]: {
    display: 'block'
  }
}));
const TopAreaSkeleton = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(RootWrapper, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(LeftSideRoot, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LeftSideSkeletonItem, {
        height: SQUARES_SIZE,
        width: SQUARES_SIZE
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LeftSideSkeletonItem, {
        height: SQUARES_SIZE,
        width: SQUARES_SIZE
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LeftSideSkeletonItem, {
        height: SQUARES_SIZE,
        width: SQUARES_SIZE * 3
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LogoSkeleton, {
      height: "60%"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(RightSideRoot, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SearchBarSkeleton, {
        height: 38,
        width: 200
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(UnifiedSkeleton, {
        width: SQUARES_SIZE,
        height: SQUARES_SIZE
      })]
    })]
  })
});
exports.TopAreaSkeleton = TopAreaSkeleton;
